import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=2f760342&scoped=true"
import script from "./PackageDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PackageDetails.vue?vue&type=style&index=0&id=2f760342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f760342",
  null
  
)

export default component.exports